import React, { useMemo } from 'react';
import TotalCustomerStyled from './TotalCustomerStyled';
import { Box, useTheme } from '@material-ui/core';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { BarChart } from 'echarts/charts';
import { TitleComponent } from 'echarts/components';
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
import { useSelector } from 'dva';
import { fmtPercent } from '@/utils/comUtil';
import { transNum } from '@/utils/comUtil';
import Loading from '@/components/LoadingML/LoadingML';
// import { fmtThousand } from '@/utils/comUtil';
// import TooltipsML from '@/components/TooltipsML/TooltipsML';
import { useIntl } from 'umi';
echarts.use([TitleComponent, CanvasRenderer, BarChart]);

// 图表容器样式提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };

const TotalCustomer = () => {
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const totalCustomerV2 = useSelector((state) => state.bhc.totalCustomerV2);

  // const BHC_TOTAL_CUSTOMER = useSelector(
  //   (state) => state.bhc.BHC_TOTAL_CUSTOMER,
  // );

  // const BHC_NEW_CUSTOMER = useSelector((state) => state.bhc.BHC_NEW_CUSTOMER);

  // const BHC_EXISTING_CUSTOMER = useSelector(
  //   (state) => state.bhc.BHC_EXISTING_CUSTOMER,
  // );

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['bhc/getTotalCustomer'];

  const totalCustomer = totalCustomerV2.totalPurchaseMemberCount;
  const customerIncreaseRate =
    totalCustomerV2.totalPurchaseMemberCountYearOverYear;

  // const salesNum = totalCustomerV2.salesNum;
  // const salesNumIncreaseRate = totalCustomerV2.salesNumIncreaseRate;
  const newMember = totalCustomerV2.newMemberRatio;
  const existingMember = totalCustomerV2.oldMemberRatio;

  const CustomerNum = totalCustomerV2.newMemberPurchaseCount;
  const CustomerRate = totalCustomerV2.newMemberPurchaseCountYearOverYear;
  const CustomerSales = totalCustomerV2.newMemberSalesAmount;
  const CustomerSalesRate = totalCustomerV2.newMemberSalesAmountYearOverYear;
  const ExitCustomerNum = totalCustomerV2.oldMemberPurchaseCount;
  const ExitCustomerRate = totalCustomerV2.oldMemberPurchaseCountYearOverYear;
  const ExitCustomerSales = totalCustomerV2.oldMemberSalesAmount;
  const ExitCustomerSalesRate =
    totalCustomerV2.oldMemberSalesAmountYearOverYear;

  const barNewMemberData = useMemo(() => {
    let data = [];
    data.push(newMember * 100);
    return data;
  }, [newMember]);

  const barExistingMemberData = useMemo(() => {
    let data = [];
    data.push(existingMember * 100);
    return data;
  }, [existingMember]);

  // const barNonMemberData = useMemo(() => {
  //   let data = [];
  //   data.push(nonMember * 100);
  //   return data;
  // }, [nonMember]);

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    let option = {
      tooltip: {
        // // trigger: 'axis',
        // triggerOn: false,
        show: false,
        // axisPointer: {
        //   // Use axis to trigger tooltip
        //   type: 'shadow',
        // },
      },
      // legend: {},
      grid: {
        left: '0%',
        right: '0%',
        top: '0%',
        // bottom: '95%',
        // containLabel: true,
        width: '100%',
        // width: '460',
        height: '100%',
      },
      xAxis: {
        type: 'value',
        show: false,
        max: 100,
      },
      yAxis: {
        show: false,
        type: 'category',
        data: ['Mon'],
      },
      series: [
        {
          name: 'Direct',
          type: 'bar',
          stack: 'total',
          label: {
            show: false,
          },
          emphasis: {
            focus: 'series',
          },
          data: barNewMemberData,
          color: '#1D8FC0',
          itemStyle: {
            borderRadius:
              barExistingMemberData[0] > 0 ? [6, 0, 0, 6] : [6, 6, 6, 6],
          },
        },
        {
          name: 'Mail Ad',
          type: 'bar',
          stack: 'total',
          label: {
            show: false,
          },
          emphasis: {
            focus: 'series',
          },
          data: barExistingMemberData,
          color: '#9E9E9E',
          itemStyle: {
            borderRadius: barNewMemberData[0] > 0 ? [0, 6, 6, 0] : [6, 6, 6, 6],
          },
        },
        // {
        //   name: 'Affiliate Ad',
        //   type: 'bar',
        //   stack: 'total',
        //   label: {
        //     show: false,
        //   },
        //   emphasis: {
        //     focus: 'series',
        //   },
        //   data: barNonMemberData,
        //   color: '#9E9E9E',
        //   itemStyle: {
        //     borderRadius: [0, 3, 3, 0],
        //   },
        // },
      ],
    };
    return option;
  }, [barExistingMemberData, barNewMemberData]);

  return (
    <TotalCustomerStyled theme={theme}>
      {/* 左侧数据展示 */}
      <Loading loading={loading}>
        <div className="customer-wrap">
          <Box className="sales-left">
            <div className="sales-top-wrap">
              <div className="sales-icon-wrap">
                <SvgIcon name="customer" size={22} color="#1565C0" />
                <div className="customer-num-wrap">
                  {/* 总购买会员数 */}
                  {formatMessage({ id: 'report.health.n04.lbl01' })}
                  {/* <TooltipsML
                    isAbsolute={true}
                    left={'96px'}
                    top={'-4px'}
                    // title={'在统计范围内，总购买金额大于0的会员数'}
                    title={formatMessage({ id: 'report.health.n04.tip02' })}
                  ></TooltipsML> */}
                </div>
              </div>
              {/* 数据 */}
              <div className="sales-evol-wrap">
                <div className="sales-evol-wrap-top">
                  <div className="sales-evol-wrap-top-left">
                    {/* <span className="amount-tag"></span> */}
                    <span className="amount-tag">
                      {transNum(totalCustomer)}
                    </span>
                  </div>
                  <div className="sales-evol-wrap-top-right">
                    <span className="amount-evol">
                      {formatMessage({ id: 'report.health.n03.lbl08' })}
                    </span>
                    <span
                      className={
                        customerIncreaseRate >= 0
                          ? 'percent-up'
                          : 'percent-down'
                      }
                    >
                      {fmtPercent(customerIncreaseRate, 2)}
                      {customerIncreaseRate ? (
                        <SvgIcon
                          name={
                            customerIncreaseRate >= 0
                              ? 'numberUp'
                              : 'numberDown'
                          }
                          size={11}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
                <div className="sales-evol-wrap-bottom">
                  <div className="sales-evol-wrap-bottom-left">
                    {/* 双数 */}
                    {/* <span className="amount-paa">
                      {formatMessage({ id: 'report.health.n04.lbl04' })}
                    </span>
                    <span className="amount-paa-num">
                      {fmtThousand(salesNum)}
                    </span> */}
                  </div>

                  <div>
                    <div className="sales-evol-wrap-top-right">
                      {/* <span className="amount-evol">
                        {formatMessage({ id: 'report.health.n03.lbl08' })}
                      </span>
                      <span
                        className={
                          salesNumIncreaseRate >= 0
                            ? 'percent-up'
                            : 'percent-down'
                        }
                      >
                        {fmtPercent(salesNumIncreaseRate, 2)}
                        {salesNumIncreaseRate ? (
                          <SvgIcon
                            name={
                              salesNumIncreaseRate >= 0
                                ? 'numberUp'
                                : 'numberDown'
                            }
                            size={11}
                            color="#1565C0"
                          />
                        ) : (
                          ''
                        )}
                      </span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 进度条占比 */}
            <Box className="sales-bottom-wrap">
              <div className="member-percent">
                <span style={{ color: '#1D8FC0' }}>
                  <div>{formatMessage({ id: 'report.health.n04.lbl07' })}</div>
                  {fmtPercent(newMember, 2)}
                </span>
                <span style={{ color: '#424242' }}>
                  <div>{formatMessage({ id: 'report.health.n03.lbl10' })}</div>
                  {fmtPercent(existingMember, 2)}
                </span>
                {/* <span style={{ color: '#9E9E9E' }}>
              非会员{fmtPercent(nonMember, 2)}
            </span> */}
              </div>
              {/* 进度条 */}
              <Box className="progress-wrap">
                <ReactEChartsCore
                  echarts={echarts}
                  lazyUpdate={true}
                  option={chartOption}
                  notMerge={true}
                  style={CHART_STYLE}
                />
                {/* <TooltipsML
                  title={formatMessage({ id: 'report.health.n04.tip09' })}
                ></TooltipsML> */}
              </Box>
            </Box>
          </Box>
          <Box className="customer-right">
            <div className="right-wrap">
              <div className="customer-title-wrap">
                <SvgIcon name={'newMember'} size={20} color="#1565C0" />
                <span className="customer-title">
                  {formatMessage({ id: 'report.health.n04.lbl07' })}
                  {/* <TooltipsML
                    // title={'根据会员注册时间，在统计时间内注册的为新会员'}
                    title={formatMessage({ id: 'report.health.n04.tip11' })}
                    isAbsolute={true}
                    right={'-14px'}
                    top={'-9px'}
                  ></TooltipsML> */}
                </span>
              </div>
              <div className="customer-data-wrap">
                <div className="customer-data-list">
                  <span className="customer-data-list-name">
                    {/* 总购买会员数 */}
                    {formatMessage({ id: 'report.health.n04.lbl12' })}
                    {/* <TooltipsML
                      // title={'根据会员注册时间，在统计时间内注册的会员总数'}
                      title={formatMessage({ id: 'report.health.n04.tip13' })}
                    ></TooltipsML> */}
                  </span>
                  <span className="customer-data-list-value">
                    {transNum(CustomerNum)}
                  </span>
                  <div>
                    {/* 左边 */}
                    <span className="customer-data-list-evol">
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                    </span>
                    <span
                      className={
                        CustomerRate >= 0
                          ? 'customer-data-list-rate'
                          : 'customer-data-list-rate-down'
                      }
                    >
                      {fmtPercent(CustomerRate, 2)}
                      {CustomerRate ? (
                        <SvgIcon
                          name={CustomerRate >= 0 ? 'numberUp' : 'numberDown'}
                          size={8}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
                <div className="customer-data-list">
                  <span className="customer-data-list-name">
                    {/* 会员销售金额 */}
                    {formatMessage({ id: 'report.health.n04.lbl20' })}
                    {/* <TooltipsML
                      // title={
                      //   '根据会员注册时间，在统计时间内注册的会员的购买金额'
                      // }
                      title={formatMessage({ id: 'report.health.n04.tip15' })}
                    ></TooltipsML> */}
                  </span>
                  <span className="customer-data-list-value">
                    <span className="customer-data-rmb">¥</span>
                    {transNum(CustomerSales)}
                  </span>
                  {/* 右边 */}
                  <div>
                    <span className="customer-data-list-evol">
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                    </span>
                    <span
                      className={
                        CustomerSalesRate >= 0
                          ? 'customer-data-list-rate'
                          : 'customer-data-list-rate-down'
                      }
                    >
                      {fmtPercent(CustomerSalesRate, 2)}
                      {CustomerSalesRate ? (
                        <SvgIcon
                          name={
                            CustomerSalesRate >= 0 ? 'numberUp' : 'numberDown'
                          }
                          size={8}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right-wrap">
              <div className="customer-title-wrap">
                <SvgIcon name={'excitedMember'} size={20} color="#1565C0" />
                <span className="customer-title">
                  {formatMessage({ id: 'report.health.n03.lbl10' })}
                  {/* <TooltipsML
                    // title={'根据会员注册时间，在统计时间之前注册的为老会员'}
                    title={formatMessage({ id: 'report.health.n04.tip17' })}
                    isAbsolute={true}
                    right={'-14px'}
                    top={'-9px'}
                  ></TooltipsML> */}
                </span>
              </div>
              <div className="customer-data-wrap">
                <div className="customer-data-list">
                  <span className="customer-data-list-name">
                    {/* 总购买会员数 */}
                    {formatMessage({ id: 'report.health.n04.lbl12' })}
                    {/* <TooltipsML
                      // title={'根据会员注册时间，在统计时间之前注册的会员总数'}
                      title={formatMessage({ id: 'report.health.n04.tip19' })}
                    ></TooltipsML> */}
                  </span>
                  <span className="customer-data-list-value">
                    {transNum(ExitCustomerNum)}
                  </span>
                  <div>
                    {/* 左边 */}
                    <span className="customer-data-list-evol">
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                    </span>
                    <span
                      className={
                        ExitCustomerRate >= 0
                          ? 'customer-data-list-rate'
                          : 'customer-data-list-rate-down'
                      }
                    >
                      {fmtPercent(ExitCustomerRate, 2)}
                      {ExitCustomerRate ? (
                        <SvgIcon
                          name={
                            ExitCustomerRate >= 0 ? 'numberUp' : 'numberDown'
                          }
                          size={8}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
                <div className="customer-data-list">
                  <span className="customer-data-list-name">
                    {/* 会员销售金额 */}
                    {formatMessage({ id: 'report.health.n04.lbl20' })}
                    {/* <TooltipsML
                      // title={
                      //   '根据会员注册时间，在统计时间之前注册的会员的购买金额'
                      // }
                      title={formatMessage({ id: 'report.health.n04.tip21' })}
                    ></TooltipsML> */}
                  </span>
                  <span className="customer-data-list-value">
                    <span className="customer-data-rmb">¥</span>
                    {transNum(ExitCustomerSales)}
                  </span>
                  {/* 右边 */}
                  <div>
                    <span className="customer-data-list-evol">
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                    </span>
                    <span
                      className={
                        ExitCustomerSalesRate >= 0
                          ? 'customer-data-list-rate'
                          : 'customer-data-list-rate-down'
                      }
                    >
                      {fmtPercent(ExitCustomerSalesRate, 2)}
                      {ExitCustomerSalesRate ? (
                        <SvgIcon
                          name={
                            ExitCustomerSalesRate >= 0
                              ? 'numberUp'
                              : 'numberDown'
                          }
                          size={8}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Loading>
    </TotalCustomerStyled>
  );
};

export default TotalCustomer;
